<div
  class="flex w-[396px] flex-col gap-5 bg-surface-0 p-12 shadow-xl shadow-surface-200
    rounded-border">
  <div>
    <h3 class="mb-2 font-medium text-surface-900" i18n>Verification</h3>
    <small class="mb-1 font-medium text-surface-600" i18n>
      We have sent PIN code to your email:
    </small>
    <small class="flex items-center font-medium text-surface-900">
      <ng-icon name="phosphorEnvelopeSimple" class="mr-1 text-xl"></ng-icon>
      {{ userStore.get().email }}
    </small>
  </div>

  <form class="flex w-full justify-center" [formGroup]="twoFAForm">
    <p-inputotp
      [integerOnly]="true"
      placeholder="0"
      class="!gap-2"
      [ngClass]="{ 'is-valid': isValid() }"
      [length]="6"
      formControlName="twoFA" />
  </form>

  <small class="flex items-center font-medium text-surface-900">
    <span class="inline-flex items-center" i18n>
      Your code expires in:
      <ng-icon name="phosphorClock" class="ml-1 mr-1 text-xl"></ng-icon>
      {{ countdown() * 1000 | date: 'mm:ss' }}
    </span>
  </small>

  <error-small-component></error-small-component>

  <div class="flex gap-2">
    <button
      pButton
      pRipple
      [outlined]="true"
      label="Cancel"
      class="w-full !text-sm"
      (click)="navigationService.back()"></button>
    <button
      pButton
      pRipple
      label="Verify"
      class="w-full !text-sm"
      (click)="verify()"></button>
  </div>
</div>
